// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { GlobalRole } from '../../api/types';
import styles from './RoleSummary.module.css';

export interface RoleSummaryProps {
  roles: readonly GlobalRole[];
  labels: Record<GlobalRole, string>;
  hints: Record<GlobalRole, string>;
  /** Active accounts per role; omitted while the list loads. */
  counts?: Record<GlobalRole, number>;
}

/** The account-wide roles side by side: name, how many hold it, and what it may do. */
export function RoleSummary({ roles, labels, hints, counts }: RoleSummaryProps) {
  return (
    <dl className={styles.roles}>
      {roles.map((role) => (
        <div key={role} className={styles.role} data-role={role}>
          <dt className={styles.name}>
            {labels[role]}
            {counts && <span className={`${styles.count} mono`}>{counts[role]}</span>}
          </dt>
          <dd className={styles.hint}>{hints[role]}</dd>
        </div>
      ))}
    </dl>
  );
}
